import { useFormContext, useWatch } from "react-hook-form";

import {
  CommonLabel,
  ContentWrapper,
  InputAndLabelWrapper,
  InputRowWrapper,
} from "../styles";
import CustomSelect from "../inputs/CustomSelect";
import CustomSelectWithCheckbox from "../inputs/CustomSelectWithCheckbox";
import YesOrNoQuestion from "./subForms/YesOrNoQuestion";
import { useTranslation } from "react-i18next";
import {
  ACCOUNT_PURPOSES_DEFAULT_VALUES,
  ACCOUNT_PURPOSES_VALUE,
  YES_NO_VAL,
} from "./utils";
import Fatca from "./Fatca";
import Pep from "./Pep";
import TaxResidency from "./TaxResidency";

function PersonDetails(props) {
  const {
    fullCountries,
    texClassifications,
    pepCategory,
    person,
    isPep,
    hasKycScore,
    accountPurposes,
    creditDebitCountries,
    isKeepz,
  } = props;

  const { t } = useTranslation();
  const { register, unregister, setValue } = useFormContext();

  const { intTransfers } = ACCOUNT_PURPOSES_VALUE;

  const dualCitizenShipValue = useWatch({ name: "dualCitizenShip" });
  const isGreenCardHolderValue = useWatch({ name: "isGreenCardHolder" });
  const accountPurposesValue = useWatch({ name: "accountPurposes" });

  const hasDualSCitizenship = Number(dualCitizenShipValue) === YES_NO_VAL.yes;
  const hasGreenCard = Number(isGreenCardHolderValue) === YES_NO_VAL.yes;
  const showTransferCountries = accountPurposesValue?.some(
    (item) => item?.value === intTransfers
  );

  const accountPurposesDefault = accountPurposes?.filter((item) =>
    ACCOUNT_PURPOSES_DEFAULT_VALUES.includes(item?.value)
  );

  function handleHasDualCitizenshipChange(value) {
    if (Number(value) === YES_NO_VAL.no) {
      unregister("countryOfCitizenship");
      if (!isPep && !hasKycScore) {
        unregister("kyc");
      }
    }
  }

  function handleHasGreenCardChange(value) {
    if (Number(value) === YES_NO_VAL.no) {
      unregister(["greenCard", "usaTaxPayer", "fatca"]);
    }
  }

  function handleCountryOfCitizenshipChange() {
    setValue("kyc.agreement", null);
    setValue("kyc.assets", null);
    setValue("kyc.estimatedCash", null);
    setValue("kyc.moneySourcesOptions", null);
    setValue("kyc.monthlyTurnovers", null);
    setValue("kyc.otherAssets", null);
    setValue("kyc.otherMoneySources", null);
    setValue("kyc.otherPropertySources", null);
    setValue("kyc.propertySources", null);
    setValue("kyc.infoCounterparties", null);
  }

  function handleAccountPurposesChange(option) {
    const hasTransferPurpose = option?.some(
      (item) => item?.value === intTransfers
    );

    if (!hasTransferPurpose) {
      unregister("transferCountries");
    }
  }

  return (
    <ContentWrapper>
      {!isKeepz ? (
        <>
          <YesOrNoQuestion
            label={t("haveDualCitizenShip")}
            name="dualCitizenShip"
            register={register}
            handleChange={(e) => {
              handleHasDualCitizenshipChange(e.target.value);
            }}
          />
          {hasDualSCitizenship ? (
            <InputRowWrapper>
              <InputAndLabelWrapper>
                <CommonLabel>{t("cityzenShipCountry")}</CommonLabel>
                <CustomSelect
                  name="countryOfCitizenship"
                  options={fullCountries}
                  rules={{ required: t("required") }}
                  handleChange={handleCountryOfCitizenshipChange}
                />
              </InputAndLabelWrapper>
            </InputRowWrapper>
          ) : null}
        </>
      ) : null}

      <YesOrNoQuestion
        label={t("tax_payer")}
        name="isGreenCardHolder"
        register={register}
        handleChange={(e) => {
          handleHasGreenCardChange(e.target.value);
        }}
      />

      {hasGreenCard ? <Fatca texClassifications={texClassifications} /> : null}

      <TaxResidency register={register} countryList={fullCountries} />

      <Pep pepCategory={pepCategory} person={person} isPep={isPep} />

      <InputRowWrapper>
        <InputAndLabelWrapper>
          <CommonLabel>{t("services_which_you_use")}</CommonLabel>
          <CustomSelectWithCheckbox
            name="accountPurposes"
            options={accountPurposes}
            rules={{ required: t("required") }}
            defaultValue={accountPurposesDefault || []}
            handleChange={handleAccountPurposesChange}
          />
        </InputAndLabelWrapper>
      </InputRowWrapper>
      {showTransferCountries ? (
        <InputRowWrapper>
          <InputAndLabelWrapper>
            <CommonLabel>{t("settlement_countries")}</CommonLabel>
            <CustomSelectWithCheckbox
              name="transferCountries"
              options={creditDebitCountries}
              rules={{ required: t("required") }}
            />
          </InputAndLabelWrapper>
        </InputRowWrapper>
      ) : null}
    </ContentWrapper>
  );
}
export default PersonDetails;
